(function () {
  angular.module("akitabox.ui.dialogs.inspectionProgram.cancel", [
    "akitabox.core.constants",
    "akitabox.core.services.inspectionProgram",
    "akitabox.core.toast",
  ]);
})();
